var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF4A4A",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.328 18.981h-1.012a.346.346 0 01-.347-.347v-2.662l-1.772 1.106a.458.458 0 01-.488 0l-1.762-1.106v2.662c0 .188-.15.347-.347.347h-1.003a.346.346 0 01-.347-.347v-5.137a.46.46 0 01.46-.46c.093 0 .177.029.252.085l2.794 1.922a.323.323 0 00.385 0l2.793-1.922a.464.464 0 01.722.375v5.137a.33.33 0 01-.328.347zm-8.588-.009H4.46a.46.46 0 01-.46-.46v-5.165A.354.354 0 014.356 13H5.37c.187 0 .347.15.347.347v3.928h3.806v-3.928c0-.188.15-.347.347-.347h.984c.188 0 .347.15.347.347v5.166a.46.46 0 01-.46.459zM21.184 13h6.282a.46.46 0 01.459.46v5.165c0 .188-.15.347-.338.347h-1.012a.346.346 0 01-.347-.347v-3.703a.228.228 0 00-.225-.225h-3.347a.228.228 0 00-.225.225v3.703c0 .188-.15.347-.347.347h-1.012a.346.346 0 01-.347-.347v-5.166a.46.46 0 01.46-.459z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.819 15.784h1.003c.187 0 .347.15.347.347v1.022c0 .188-.15.347-.347.347h-1.003a.346.346 0 01-.347-.347v-1.031c0-.188.16-.338.347-.338z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUma);
export default __webpack_public_path__ + "static/media/uma.13e117ba7a4710ac2e782e2d6d0ee2a4.svg";
export { ForwardRef as ReactComponent };